import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { dateFormat } from 'common/helpers/dateHelper';

const ClubShipDate = (props) => {
  const { clubPackage, clubMemberShipment, router } = props;
  const settings = useSelector((state) => state.setting);

  switch (clubMemberShipment.processingStatus) {
    case 'Pending': {
      return (
        <>
          Your next shipment is{' '}
          <span>{dateFormat(clubPackage.processDate, settings)}</span>
        </>
      );
    }
    case 'Skip': {
      return (
        <>
          Your shipment is marked skipped and will not be processed.
          <br />
          The shipment is scheduled for{' '}
          {dateFormat(clubPackage.processDate, settings)}
        </>
      );
    }
    case 'Completed':
    case 'Processing': {
      if (router === 'router') {
        return (
          <>
            Your shipment was recently processed. See order number{' '}
            <Link to={`/profile/order-history/${clubMemberShipment.orderId}`}>
              {clubMemberShipment.orderNumber}.
            </Link>
          </>
        );
      }
      return (
        <>
          Your shipment was recently processed. See order number{' '}
          <a href={`/profile/order-history/${clubMemberShipment.orderId}`}>
            {clubMemberShipment.orderNumber}.
          </a>
        </>
      );
    }
    default: {
      throw Error('Invalid club membershipment processingStatus');
    }
  }
};

export default ClubShipDate;
